<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <Trackers />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Trackers from '@/components/reports/trackers/Trackers'

export default {
  name: 'TrackersView',
  components: {
    PageTitle,
    PageRowWrapper,
    Trackers
  }
}
</script>